import React, { useEffect, useState } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { WxLaunchHack } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchHack/dynamic';
import ViewMore from '@src/mobile/components/viewMore';
import type { CommentItem } from '@src/services/commentApi';
import { getQuery, commentApi } from '@src/utils';
import styles from './index.css';
import Item from './Item';

type AllData = {
    content: {
        pageId: string;
        doc_url: string;
        user_id?: string | null;
    };
};

const Comment: React.FC<AllData> = ({ content }) => {
    const { pageId, doc_url, user_id: authorId } = content;

    const [initDone, setInitDone] = useState(false);
    const [comments, setComments] = useState<CommentItem[]>([]);

    const userId = getQuery(window.location.href, 'userId') || '';

    useEffect(() => {
        commentApi.v3
            .getCommentsList({ doc_url, p: 0, orderby: 'integral' })
            .then((res) => {
                if (res.data) {
                    const { comments: list } = res.data;

                    if (Array.isArray(list) && list.length) {
                        setComments(list);
                    }
                }
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                setInitDone(true);
            });
    }, [doc_url]);

    const wxLaunchHackData = {
        callAppConfig: {
            docType: 'flutter',
            pid: `/detail?id=${pageId}&ref=outside`,
            kind: 'inter_txs05',
            noKindFrom: 1,
            download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1388318126244',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8991',
        },
        statisticsConfig: {
            behavior: 'action',
            type: 'sharepage_app_start',
            button_name: 'f',
            user_id: userId,
        },
    };

    const moreCallAppData = {
        docType: 'flutter',
        pid: `/detail?id=${pageId}&ref=outside`,
        kind: 'inter_txs09',
        noKindFrom: 1,
        download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1367752534964',
        downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8995',
    };

    return (
        <div className={styles.comment}>
            <div className={styles.head}>
                <div className={styles.headTitle}>热门评论</div>
                <div className={styles.headSort}>
                    <div className={styles.headSortIcon} />
                    <div className={styles.headSortText}>按热门</div>
                    <WxLaunchHack content={wxLaunchHackData} />
                </div>
            </div>
            {initDone ? (
                <>
                    {comments.length ? (
                        <>
                            <div>
                                {comments.slice(0, 3).map((item) => (
                                    <Item content={{ data: item, authorId, pageId }} key={item.comment_id} />
                                ))}
                            </div>
                            <ViewMore
                                content={{
                                    hasBorder: false,
                                    callAppData: moreCallAppData,
                                    statisticsData: {
                                        behavior: 'action',
                                        type: 'sharepage_app_start',
                                        button_name: 'j',
                                        user_id: userId,
                                    },
                                }}
                            />
                        </>
                    ) : (
                        <div className={styles.empty}>
                            <div className={styles.emptyImg} />
                            <div className={styles.emptyText}>抢先发表观点，更容易上热评</div>
                        </div>
                    )}
                </>
            ) : (
                <div className={styles.loading} />
            )}
        </div>
    );
};

export default errorBoundary(Comment);
